import { x as a, c as tt } from "../lit-element-8JrrHldg.js";
import { n as p } from "../property-4FoNj0Pi.js";
import { r as et } from "../state-D4BCZ2JK.js";
import { n as st } from "../ref-ArR26hg7.js";
import { I as ot } from "../IdController-Cpj_A6H5.js";
import "./pwc-label.js";
import "./pwc-input-surface.js";
import "./pwc-input-message.js";
import "./pwc-icon.js";
import { t as pt } from "../time-B7nTmSbZ.js";
import { o as n } from "../if-defined-Cd-e8xtV.js";
import { c as x } from "../clsx-DB4S2d7J.js";
import { P as nt } from "../pwc-interactive-element-B6286Ky3.js";
import { p as d } from "../pwcProperty-CTLG9yrF.js";
import "../cross-De9fASU6.js";
let it = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="m2.62 11.255.715-.71A7.03 7.03 0 0 1 1.535 8C2.55 5.465 5.35 3.5 8 3.5a6.19 6.19 0 0 1 2 .36l.775-.78A7.36 7.36 0 0 0 8 2.5 8.345 8.345 0 0 0 .53 7.83a.5.5 0 0 0 0 .34 8 8 0 0 0 2.09 3.085Z"></path><path d="M6 7.865a2 2 0 0 1 1.85-1.85l.905-.91A3 3 0 0 0 5.09 8.77L6 7.865Zm9.47-.035a8.2 8.2 0 0 0-2.87-3.72L15 1.705 14.295 1 1 14.295l.705.705 2.55-2.55A7.645 7.645 0 0 0 8 13.5a8.346 8.346 0 0 0 7.47-5.33.5.5 0 0 0 0-.34ZM10 8a2 2 0 0 1-3 1.72L9.72 7A2 2 0 0 1 10 8Zm-2 4.5a6.524 6.524 0 0 1-3-.79l1.27-1.27a3 3 0 0 0 4.175-4.175L11.88 4.83A7.27 7.27 0 0 1 14.465 8C13.45 10.535 10.65 12.5 8 12.5Z"></path></svg>';
  }
};
const S = "pi-eye-off";
customElements.get(S) || customElements.define(S, it);
class rt extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M15.47 7.83A8.345 8.345 0 0 0 8 2.5 8.345 8.345 0 0 0 .53 7.83a.5.5 0 0 0 0 .34A8.345 8.345 0 0 0 8 13.5a8.345 8.345 0 0 0 7.47-5.33.5.5 0 0 0 0-.34ZM5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm1 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM1.535 8C2.55 10.535 5.35 12.5 8 12.5s5.45-1.965 6.465-4.5C13.45 5.465 10.65 3.5 8 3.5S2.55 5.465 1.535 8Z" clip-rule="evenodd"></path></svg>';
  }
}
const C = "pi-eye";
customElements.get(C) || customElements.define(C, rt);
var at = Object.defineProperty, lt = Object.getOwnPropertyDescriptor, e = (s, o, i, l) => {
  for (var r = l > 1 ? void 0 : l ? lt(o, i) : o, c = s.length - 1, u; c >= 0; c--)
    (u = s[c]) && (r = (l ? u(o, i, r) : u(r)) || r);
  return l && r && at(o, i, r), r;
}, ct = (s, o, i) => {
  if (!o.has(s))
    throw TypeError("Cannot " + i);
}, M = (s, o, i) => {
  if (o.has(s))
    throw TypeError("Cannot add the same private member more than once");
  o instanceof WeakSet ? o.add(s) : o.set(s, i);
}, T = (s, o, i) => (ct(s, o, "access private method"), i), g, B, w, L;
const E = "pwc-input";
let t = class extends nt {
  constructor() {
    super(...arguments), M(this, g), M(this, w), this.showPass = !1, this.idController = new ot(this, {
      base: "PwcInput",
      children: ["label", "input"]
    }), this.slotControlled = ["label"];
  }
  clear() {
    this.value = "", this.emit("p-input", { detail: "" }), this.focus();
  }
  togglePassword() {
    this.showPass = !this.showPass;
  }
  get showPasswordToggle() {
    return this.type === "password" && this.passwordToggle;
  }
  get passwordInputType() {
    return this.passwordToggle && this.showPass ? "text" : "password";
  }
  get showClearButton() {
    return this.clearable && !(this.hidden || this.disabled) && String(this.value).length;
  }
  get describedBy() {
    return this.description ? `${this.idController.child.label}__description` : void 0;
  }
  render() {
    const {
      name: s,
      type: o,
      value: i,
      label: l,
      step: r,
      placeholder: c,
      description: u,
      describedBy: A,
      focused: y,
      autofocus: Z,
      readonly: $,
      disabled: h,
      required: f,
      noSpinButtons: N,
      showPasswordToggle: z,
      counter: H,
      min: O,
      max: R,
      minlength: q,
      maxlength: m,
      iconLeft: _,
      iconRight: v,
      textLeft: b,
      errorMessages: D,
      warningMessages: W,
      successMessages: k,
      hintMessage: j,
      hideDetails: F,
      status: G,
      title: J,
      pattern: K,
      idController: {
        id: Q,
        child: { label: U, input: P }
      },
      slotted: V,
      autocomplete: X,
      multiple: Y,
      size: I
    } = this;
    return a`
      <div
        id=${Q}
        class="PwcInput ${x({
      "PwcInput--sized": !!I
    })}"
      >
        <pwc-label
          id=${U}
          class="PwcInput__label"
          for=${P}
          description=${n(u)}
          ?disabled=${h}
          ?required=${f}
        >
          ${V.label ? "" : l}
          <p-slot .host=${this} name="label"></p-slot>
          <p-slot
            .host=${this}
            name="description"
            p-slot="description"
          ></p-slot>
        </pwc-label>

        <div class="PwcInput__inner">
          <p-slot .host=${this} name="prepend-outer"></p-slot>
          <pwc-input-surface
            class="PwcInput__inputSurface"
            status=${n(G)}
            ?focused=${y}
            ?readonly=${$}
            ?disabled=${h}
          >
            <p-slot .host=${this} name="prepend"></p-slot>
            ${_ ? a` <pwc-icon
                  class="PwcInput__iconLeft"
                  icon=${_}
                ></pwc-icon>` : ""}
            ${b ? a`<span class="PwcInput__textLeft">${b}</span>` : ""}
            <input
              ${st(this.interactiveElementRef)}
              id=${P}
              class=${x("PwcInput__input", {
      "PwcInput__input--noSpinButtons": N
    })}
              aria-describedby=${n(A)}
              name=${n(s)}
              type=${o === "password" ? this.passwordInputType : o}
              autocomplete=${n(X)}
              size=${n(I)}
              min=${n(O)}
              max=${n(R)}
              minlength=${n(q)}
              maxlength=${n(m)}
              step=${n(r)}
              title=${n(J)}
              pattern=${n(K)}
              placeholder=${n(c)}
              .value=${i}
              ?multiple=${Y}
              ?autofocus=${Z}
              ?readonly=${$}
              ?disabled=${h}
              ?required=${f}
              @input=${T(this, g, B)}
              @change=${T(this, w, L)}
            />
            ${z ? a` <button
                  type="button"
                  class="PwcInput__passwordToggle"
                  @click=${this.togglePassword}
                >
                  <pwc-icon
                    class="PwcInput__passwordToggle__icon"
                    icon=${this.showPass ? "eye-off" : "eye"}
                  >
                  </pwc-icon>
                </button>` : ""}
            ${this.showClearButton ? a` <button
                  type="button"
                  class="PwcInput__clear"
                  @click=${this.clear}
                >
                  <pwc-icon
                    class="PwcInput__clear__icon"
                    icon="cross"
                  ></pwc-icon>
                </button>` : ""}
            ${v ? a` <pwc-icon
                  class="PwcInput__iconRight"
                  icon=${v}
                ></pwc-icon>` : ""}
            <p-slot .host=${this} name="append"></p-slot>
          </pwc-input-surface>
          <p-slot .host=${this} name="append-outer"></p-slot>
        </div>
        <div class="PwcInput__bottom">
          ${F ? "" : a` <pwc-input-message
                .errorMessages=${D}
                .warningMessages=${W}
                .successMessages=${k}
                .hintMessage=${y && j || void 0}
              ></pwc-input-message>`}
          ${H ? a` <div class="PwcInput__counter">
                ${m ? m - i.length : i.length}
              </div>` : ""}
        </div>
      </div>
    `;
  }
};
g = /* @__PURE__ */ new WeakSet();
B = async function(s) {
  await pt();
  const o = this.value = s.target.value;
  this.emit("p-input", { detail: o });
};
w = /* @__PURE__ */ new WeakSet();
L = function(s) {
  this.emit("p-change", this.event(s));
};
t.tagName = E;
t.inputTypes = [
  "text",
  "search",
  "tel",
  "url",
  "email",
  "password",
  "number"
];
e([
  d({ type: String, default: "text" })
], t.prototype, "type", 2);
e([
  p({ type: String })
], t.prototype, "name", 2);
e([
  d({ type: String, default: "" })
], t.prototype, "value", 2);
e([
  p({ type: String })
], t.prototype, "label", 2);
e([
  p({ type: String })
], t.prototype, "step", 2);
e([
  d({ type: String, default: "" })
], t.prototype, "placeholder", 2);
e([
  p({ type: String })
], t.prototype, "pattern", 2);
e([
  d({ type: String, default: "" })
], t.prototype, "title", 2);
e([
  p({ type: String })
], t.prototype, "autocomplete", 2);
e([
  p({ type: Boolean })
], t.prototype, "multiple", 2);
e([
  p({ type: Number })
], t.prototype, "size", 2);
e([
  p({ type: Boolean, attribute: "no-spin-buttons" })
], t.prototype, "noSpinButtons", 2);
e([
  p({ type: Boolean })
], t.prototype, "clearable", 2);
e([
  p({ type: Boolean, attribute: "password-toggle" })
], t.prototype, "passwordToggle", 2);
e([
  d({ type: Boolean, default: !1 })
], t.prototype, "counter", 2);
e([
  p({ type: Number })
], t.prototype, "min", 2);
e([
  p({ type: Number })
], t.prototype, "max", 2);
e([
  p({ type: Number })
], t.prototype, "minlength", 2);
e([
  p({ type: Number })
], t.prototype, "maxlength", 2);
e([
  p({ type: String })
], t.prototype, "description", 2);
e([
  p({ type: String, attribute: "icon-left" })
], t.prototype, "iconLeft", 2);
e([
  p({ type: String, attribute: "icon-right" })
], t.prototype, "iconRight", 2);
e([
  p({ type: String, attribute: "text-left" })
], t.prototype, "textLeft", 2);
e([
  et()
], t.prototype, "showPass", 2);
t = e([
  tt(E)
], t);
export {
  t as PwcInput
};
